export default __webpack_public_path__ + "static/xr_glasses-0e7cf45ec496ea387c5ef7ea6acc7353.png";